import React from "react"

export function SuccessIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="126"
      height="126"
      viewBox="0 0 126 126"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="63" cy="63" r="63" fill="#0DBD29" />
      <path
        d="M42 68.4L53.1481 81L85 45"
        stroke="white"
        strokeWidth="9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
